// extracted by css-extract-rspack-plugin
export default {"navigationItem":"navigation-fragment__NavigationItem_navigationItem__qx+Ml","allExperiences":"navigation-fragment__NavigationItem_allExperiences__Jzqtx"};